"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessfulOrganisms = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var Size_1 = require("../../cards/render/Size");
var RENDER_DATA = CardRenderer_1.CardRenderer.builder(function (b) {
    b.plants(1).slash().production(function (pb) { return pb.plants(1); }).nbsp.influence({ size: Size_1.Size.SMALL });
});
var SuccessfulOrganisms = (function () {
    function SuccessfulOrganisms() {
        this.name = GlobalEventName_1.GlobalEventName.SUCCESSFUL_ORGANISMS;
        this.description = 'Gain 1 plant per plant production (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.MARS;
        this.currentDelegate = PartyName_1.PartyName.SCIENTISTS;
        this.renderData = RENDER_DATA;
    }
    SuccessfulOrganisms.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            player.addResource(Resources_1.Resources.PLANTS, Math.min(5, player.getProduction(Resources_1.Resources.PLANTS)) + turmoil.getPlayerInfluence(player), { log: true, from: _this.name });
        });
    };
    return SuccessfulOrganisms;
}());
exports.SuccessfulOrganisms = SuccessfulOrganisms;
